import React from "react";
import { useAdminEvent } from "@/context/AppContext";
import { PageIntro } from "@/admin/ui";
import { Plane, BedDouble, Wallet, Sparkles } from "lucide-react";

const MODULES = {
  travel: { icon: Plane, title: "Travel", tag: "Navan Integration — Coming Next", desc: "Import Navan booking reports and automatically connect flights with attendees. Arrival and departure times will feed the attendee My Trip experience and drive transfer scheduling." },
  "hotel-rooming": { icon: BedDouble, title: "Hotel / Rooming", tag: "Rooming Integration — Coming Next", desc: "Import hotel rooming lists to assign rooms, identify missing or conflicting assignments and surface occupancy at a glance." },
  budget: { icon: Wallet, title: "Budget", tag: "Budget & Finance — Coming Next", desc: "Track approved budget, committed spend and per-attendee cost across travel, hotel, transfers and activities." },
};

export default function FutureModule({ moduleKey }) {
  const { event } = useAdminEvent();
  const m = MODULES[moduleKey] || MODULES.travel;
  const Icon = m.icon;
  return (
    <div>
      <PageIntro>Structured placeholder for the {m.title} module. This demonstrates the platform roadmap without fabricating operational data.</PageIntro>
      <div className="premium-card p-10 text-center">
        <div className="gold-chip mx-auto mb-4"><Sparkles className="h-3.5 w-3.5" /> {m.tag}</div>
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[hsl(var(--secondary)/0.12)] text-[hsl(var(--secondary))] mb-4"><Icon className="h-8 w-8" /></div>
        <h2 className="font-serif text-3xl text-[hsl(var(--primary))]">{m.title}</h2>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-2 max-w-lg mx-auto">{m.desc}</p>
        <p className="text-xs text-[hsl(var(--muted-foreground))] mt-4">Future capability for <strong>{event?.name}</strong> · arrives in Phase 3.</p>
      </div>
    </div>
  );
}
